import type { ClientPropertyVehicleDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CarFormFields } from "web_myplann/Portfolio/Forms/CarForm/CarFormFields";
import { useEditCarForm } from "web_myplann/Portfolio/Forms/CarForm/useEditCarForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditCarFormProps = {
	propertyId: number;
	property: ClientPropertyVehicleDetailResponseDTO;
	detailRoute: string;
};

export const EditCarForm = ({
	propertyId,
	property,
	detailRoute,
}: EditCarFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } = useEditCarForm({
		propertyId,
		property,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditProperty.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<CarFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
